// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__sH6kN","spinnerCircle":"Spinner_spinnerCircle__DdudG","spin":"Spinner_spin__Fp7xd"};